const DEFAULT_SOINS = [
  { code: "C001", name: "Consultation initiale", defaultPrice: 150, groups: ["Consultations", "Bookmarks"] },
  { code: "C002", name: "Consultation de contrôle", defaultPrice: 100, groups: ["Consultations", "Bookmarks"] },
  { code: "P001", name: "Détartrage complet", defaultPrice: 400, groups: ["Prévention", "Bookmarks"] },
  { code: "P002", name: "Application de fluor", defaultPrice: 150, groups: ["Prévention", "Bookmarks"] },
  { code: "R001", name: "Radiographie rétro-alvéolaire", defaultPrice: 80, groups: ["Radiologie", "Bookmarks"] },
  { code: "R002", name: "Radiographie panoramique", defaultPrice: 250, groups: ["Radiologie", "Bookmarks"] },
  { code: "SC001", name: "Obturation composite 1 face", defaultPrice: 300, groups: ["Soins conservateurs", "Bookmarks"] },
  { code: "SC002", name: "Obturation composite 2 faces", defaultPrice: 400, groups: ["Soins conservateurs", "Bookmarks"] },
  { code: "SC003", name: "Obturation composite 3 faces", defaultPrice: 500, groups: ["Soins conservateurs", "Bookmarks"] },
  { code: "EN001", name: "Traitement endodontique incisive/canine", defaultPrice: 700, groups: ["Endodontie", "Bookmarks"] },
  { code: "EN002", name: "Traitement endodontique prémolaire", defaultPrice: 900, groups: ["Endodontie", "Bookmarks"] },
  { code: "EN003", name: "Traitement endodontique molaire", defaultPrice: 1200, groups: ["Endodontie", "Bookmarks"] },
  { code: "PA001", name: "Surfaçage radiculaire par sextant", defaultPrice: 600, groups: ["Parodontologie"] },
  { code: "CH001", name: "Extraction simple", defaultPrice: 300, groups: ["Chirurgie buccale"] },
];

const DEFAULT_GROUPS = [
  "Bookmarks",
  "Consultations",
  "Prévention",
  "Radiologie",
  "Soins conservateurs",
  "Endodontie",
  "Parodontologie",
  "Chirurgie buccale",
];

export { DEFAULT_SOINS, DEFAULT_GROUPS };